var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.4 62.8",
    style: {
      enableBackground: "new 0 0 61.4 62.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#C41433;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.8,17.6c6.4,0,9.6-6.9,7.4-15.1h-46c-5.4,0-9.8,4.4-9.8,9.8v47.2c9,3,17.2-2,17.2-10.5V39h25 c5.9,0,8.9-6.3,6.9-14H19.7v-7.4H50.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightSmall);
export default __webpack_public_path__ + "static/media/logo-light-small.2cb5a56650df898425c93413fa4bc473.svg";
export { ForwardRef as ReactComponent };